"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DEFAULT_SINGLE_LINE_HEIGHT = 10;
var DEFAULT_MULTI_LINE_HEIGHT = 22;
/**
 * Paragraph component is a wrapper component around the `<p>` html
 * tags with special handling around multiple lines styling.
 */

var Paragraph =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Paragraph, _React$PureComponent);

  function Paragraph() {
    var _this;

    _classCallCheck(this, Paragraph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Paragraph).call(this));

    _this.checkForMultiLine = function () {
      if (_this.props.forceMultiLineHeight) {
        // No need to calculate light height state.
        _this.setState({
          singleLine: false
        });

        return;
      }

      var lineHeight = (0, _ReactElementUtils.getElementHeight)(_this.paragraphNode);

      if (_this.state.singleLine) {
        // currently is state set to single line.  If rendered lineHeight is
        // greater than the default single line then we switch to state to
        // multi line(!singleLine)
        if (lineHeight > DEFAULT_SINGLE_LINE_HEIGHT) {
          _this.setState({
            singleLine: false
          });
        }
      } else {
        // currently state is set to multi line.  If the rendered lineHeight is
        // equal to the default multi line height then we need to swtich to
        // single line
        // eslint-disable-next-line no-lonely-if
        if (lineHeight === DEFAULT_MULTI_LINE_HEIGHT) {
          _this.setState({
            singleLine: true
          });
        }
      }
    };

    _this.state = {
      // Control the line-height css styling when dealing with single line
      // text.
      singleLine: true
    };
    return _this;
  }

  _createClass(Paragraph, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkForMultiLine();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkForMultiLine();
      window.addEventListener('resize', this.checkForMultiLine);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.checkForMultiLine);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Take out forceMultiLineHeight so that it wouldn't pass that to <p>
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          forceMultiLineHeight = _this$props.forceMultiLineHeight,
          props = _objectWithoutProperties(_this$props, ["className", "type", "forceMultiLineHeight"]);

      var multiLineClass = this.state.singleLine ? 'single-line' : 'multi-line';

      var newProps = _objectSpread({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), " ").concat(_ThemeManager.default.getVar('classPrefix'), "-paragraph"), multiLineClass),
        ref: function ref(node) {
          _this2.paragraphNode = node;
        },
        'data-type': type
      }, props);

      return _react.default.createElement("p", newProps);
    }
  }]);

  return Paragraph;
}(_react.default.PureComponent);

exports.default = Paragraph;
Paragraph.defaultProps = {
  type: 'primary',
  forceMultiLineHeight: false
};
Paragraph.propTypes = {
  /**
   * Additional classname
   *
   * dark-bg : to style font color for use in dark background.
   * no-wrap : Forces text to stay in one line.
   */
  className: _propTypes.default.string,

  /**
   * Force paragraph text styling
   */
  type: _propTypes.default.oneOf(['primary', 'secondary', 'supplementary']),

  /**
   * Force paragraph to always use multi line height styling
   */
  forceMultiLineHeight: _propTypes.default.bool
};